import type React from 'react';

import type { IconProps } from '../types';

export const ArrowDownCircleS: React.FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.24999 17.3848 2.24999 12C2.24999 6.61522 6.61522 2.25 12 2.25ZM12 3.75C7.44364 3.75 3.74999 7.44365 3.74999 12C3.74999 16.5563 7.44364 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM12 6C12.4142 6 12.75 6.33579 12.75 6.75V15.5801L16.0019 12.6895C16.3115 12.4144 16.7854 12.4424 17.0605 12.752C17.3356 13.0615 17.3076 13.5354 16.998 13.8105L12.498 17.8105C12.345 17.9194 12.1983 18 12 18C11.8185 18 11.6375 17.931 11.5019 17.8105L6.94726 13.7568C6.68997 13.4769 6.68151 13.0423 6.93945 12.752C7.19748 12.4617 7.63028 12.4189 7.93847 12.6416L11.25 15.5801V6.75C11.25 6.33579 11.5858 6 12 6Z"
      fill={color}
    />
  </svg>
);
